import { Alert, App, Button, Popconfirm, Transfer } from "antd"

import Flex from "#blocks/Flex"

import AntdSection from "./AntdSection"

const AntdAlerts = () => {
  const { message, notification } = App.useApp()
  return (
    <Flex col gap={20} style={{ paddingBottom: 40 }}>
      <AntdSection title="Messages">
        <Button onClick={() => message.success("Success message")}>
          Success message
        </Button>
        <Button onClick={() => message.warning("Warning message")}>
          Warning message
        </Button>
        <Button onClick={() => message.error("Error message")}>
          Error message
        </Button>
      </AntdSection>

      <AntdSection title="Notifications">
        <Button
          onClick={() =>
            notification.success({
              message: "Success message",
              description: "Something went right!",
            })
          }
        >
          Success notification
        </Button>
        <Button
          onClick={() =>
            notification.info({
              message: "Info message",
              description: "Something has info!",
            })
          }
        >
          Info notification
        </Button>
        <Button
          onClick={() =>
            notification.warning({
              message: "Warning message",
              description: "Something went wrong!",
            })
          }
        >
          Warning notification
        </Button>
        <Button
          onClick={() =>
            notification.error({
              message: "Error message",
              description: "Something went very wrong!",
            })
          }
        >
          Error notification
        </Button>
      </AntdSection>

      <AntdSection title="Alerts">
        <Flex col gap={20}>
          <Flex gap={20}>
            <Alert
              message="Success Text"
              description="Something went right!"
              type="success"
              showIcon
            />
            <Alert
              message="Info Text"
              description="Something has info!"
              type="info"
              showIcon
            />
          </Flex>
          <Flex gap={20}>
            <Alert
              message="Warning Text"
              description="Something went wrong!"
              type="warning"
              showIcon
            />
            <Alert
              message="Error Text"
              description="Something went very wrong!"
              type="error"
              showIcon
            />
          </Flex>
        </Flex>
      </AntdSection>

      <AntdSection title="Pop confirmation">
        <Popconfirm
          title="Are you sure you want to delete this item?"
          okText="Yes, delete"
          cancelText="No"
        >
          <Button>Delete</Button>
        </Popconfirm>
      </AntdSection>

      <AntdSection title="Transfer">
        <Transfer
          dataSource={[
            { key: "1", title: "Item 1" },
            { key: "2", title: "Item 2" },
            { key: "3", title: "Item 3" },
            { key: "4", title: "Item 4" },
          ]}
          targetKeys={["3", "4"]}
          selectedKeys={["1", "2"]}
          titles={["Source", "Target"]}
          render={(item) => item.title}
          rowKey={(record) => record.key}
        />
      </AntdSection>
    </Flex>
  )
}

export default AntdAlerts
